export const stripHTML = ( html: string ): string => {

    let tmp = document.createElement( "div" )
    tmp.innerHTML = html
    return tmp.textContent || tmp.innerText || ""

}